
import { defineComponent } from 'vue'
import IssueDetailMixin from '~/mixins/issueDetailMixin'
import { getSilenceRuleError } from '~/utils/issue'

export default defineComponent({
  name: 'IgnoreIssueFilePattern',
  mixins: [IssueDetailMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    checkId: {
      type: String,
      default: ''
    },
    shortcode: {
      type: String,
      required: false
    },
    repositoryId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pattern: '',
      isLoading: false
    }
  },
  computed: {
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {
        pattern: this.pattern
      } as {
        repositoryId?: string
        checkId?: string
        pattern: string
        issueShortcode?: string
      }

      if (this.checkId) {
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
      } else {
        params.repositoryId = this.repositoryId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueFilePattern(params)
        this.$toast.success(`${this.issueShortcode} ignored for the specified file pattern.`)

        this.$emit('ignore', response.checkIssueIds)
      } catch (e) {
        const silenceRuleMsg = getSilenceRuleError(e)
        if (silenceRuleMsg) {
          this.$toast.danger(silenceRuleMsg)
        } else {
          this.$logErrorAndToast(
            e as Error,
            'Something went wrong while ignoring this issue, please contact support.',
            undefined,
            {
              context: 'Ignore Issue',
              params: {
                method: 'Ignore Issue File Pattern',
                ...params
              }
            }
          )
        }
      } finally {
        this.isLoading = false
      }
    }
  }
})
